/**
 * Troca a tab ativa para a próxima ou anterior, dependendo da direção.
 *
 * @param {number} tabAtual - O índice da tab atual.
 * @param {Function} setTabAtual - A função para atualizar o estado da tab ativa.
 * @param {number} direcao - A direção da troca de tab (1 para próxima, -1 para anterior).
 * @returns {void}
 */
function trocarTab(tabAtual, setTabAtual, direcao) {
  const tabs = document.querySelectorAll(".nav-link");
  const panes = document.querySelectorAll(".tab-pane");
  tabs[tabAtual].classList.remove("active");
  panes[tabAtual].classList.remove("active");

  let novaTab = tabAtual + direcao;

  if (novaTab < 0) {
    novaTab = tabs.length - 1;
  } else if (novaTab >= tabs.length) {
    novaTab = 0;
  }

  tabs[novaTab].classList.add("active");
  panes[novaTab].classList.add("active");
  setTabAtual(novaTab);
}

const TabHelper = { trocarTab };
export default TabHelper;
